module.exports = __webpack_public_path__ + "img/vg.bab510bf.svg";